import { useEffect, useState } from "react";
import { Button, Card, Empty } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import { CircleCheck, SquarePen, Trash2 } from "lucide-react";

import AssignJobTypenModal from "../components/assignJobTypeModal";

import getLabelByValue from "sr/helpers/functions/getLabelByValue";
import { getConJobType } from "sr/utils/api/company/contractor/getConJobType";
import { getJobTypeCategory } from "sr/utils/api/getJobTypeCategory";
import { deleteConJobType } from "sr/utils/api/company/contractor/deleteConJobType";

function Step3(props: any) {
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState(true);
  const [loading2, setIsLoading2] = useState(false);

  const [category, setCategory] = useState([]);

  const [openForm, setOpenForm] = useState(false);
  const [selectItem, setSelectItem] = useState({});

  const [data, setData] = useState([]);

  useEffect(() => {
    getCustomerJobTypes();
    getCategory();
  }, []);

  const getCategory = async () => {
    try {
      const response = await getJobTypeCategory();
      if (response?.success === true) {
        const options = response?.data?.map((item: any) => ({
          value: item?.value,
          label: <FormattedMessage id={item?.label} />,
        }));
        setCategory(options);
      } else {
        setCategory([]);
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const getCustomerJobTypes = async () => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append("contractor_id", props?.data?.id);
      queryParams.append("page", "1");
      queryParams.append("limit", "100");
      const response = await getConJobType(queryParams);
      if (response?.success === true) {
        setData(response?.data);
      } else {
        setData([]);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log("err", err);
    }
  };

  const editJobType = (item: any) => {
    setSelectItem(item);
    setOpenForm(!openForm);
  };

  const deleteJobType = async (id: any) => {
    try {
      setIsLoading2(id);
      const response = await deleteConJobType({ id: id });
      console.log("response", response);
      getCustomerJobTypes();
      setIsLoading2(null);
    } catch (err) {
      setIsLoading2(false);
      console.log("err", err);
    }
  };

  return (
    <div className="mt-6 mx-auto max-w-4xl pb-40">
      <Card
        title="Assign Job Types"
        loading={isLoading}
        headStyle={{ padding: 10 }}
        extra={
          <Button type="primary" onClick={() => editJobType({})}>
            Add Job Type
          </Button>
        }
      >
        {data?.length > 0 ? (
          data?.map((item: any, index: number) => (
            <div
              key={index}
              className={` flex gap-4 ${
                data?.length !== index + 1 && "border-b mb-4 pb-4"
              } `}
            >
              <div className="font-semibold text-[16px] flex-1">
                {getLabelByValue(item?.job_type, category)}
              </div>
              <div className="text-gray-900 flex-1 text-center">
                Hourly Rate: ${Number(item?.rate).toFixed(2)}
              </div>
              <div className="flex gap-2">
                <Button onClick={() => editJobType(item)}>
                  <SquarePen size={15} />
                </Button>
                <Button
                  danger
                  onClick={() => deleteJobType(item?.id)}
                  loading={loading2 === item?.id}
                >
                  <Trash2 size={15} />
                </Button>
              </div>
            </div>
          ))
        ) : (
          <Empty description="No job types assigned" />
        )}
      </Card>
      <div className="fixed bottom-0 left-0 right-0 bg-white backdrop-blur-sm border-t border-gray-200 z-1000 p-2 !pl-0 sm:!pl-[200px]">
        <div className="flex items-center mx-auto sm:max-w-4xl">
          <div>
            <Button
              size="large"
              danger
              className="!px-10"
              onClick={() => props?.onBack()}
            >
              Back
            </Button>
          </div>
          <div className="flex-1"></div>
          <div>
            <Button
              size="large"
              type="primary"
              className="!px-10"
              onClick={() => props?.onChange()}
            >
              Finish <CircleCheck size={20} />
            </Button>
          </div>
        </div>
      </div>
      {openForm ? (
        <AssignJobTypenModal
          visible={openForm}
          close={() => editJobType({})}
          currentData={data}
          company_id={props?.company_id}
          contractor_id={props?.data?.id}
          data={selectItem}
          category={category}
          onRefresh={() => {
            setIsLoading2(true);
            getCustomerJobTypes();
          }}
        />
      ) : null}
    </div>
  );
}

export default Step3;
